import React from 'react';

/** Circular indeterminate loading spinner (Wanted "Circular"). */
export function Spinner({ size = 24, thickness, color = 'var(--primary-normal)', track = 'var(--fill-strong)', style }) {
  const w = typeof thickness === 'number' ? thickness : Math.max(2, Math.round(size / 10));
  return (
    <span
      role="progressbar"
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        border: `${w}px solid ${track}`,
        borderTopColor: color,
        animation: 'wds-spin 0.7s linear infinite',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      <style>{'@keyframes wds-spin{to{transform:rotate(360deg)}}'}</style>
    </span>
  );
}

export default Spinner;
